import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=faa45bf8&scoped=true"
import script from "./TheAlert.vue?vue&type=script&lang=ts"
export * from "./TheAlert.vue?vue&type=script&lang=ts"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=faa45bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa45bf8",
  null
  
)

export default component.exports